<section
  class="filters--header"
  data-test="product-category--filters"
>
  <div class="filters--title h-500" data-test="product-category--filters-title-container">
    <mat-icon class="filters--icon" svgIcon="filter" data-test="product-category--filters-title-icon" />
    {{ 'productList.filters.title' | cxTranslate }}
    <ng-container *ngTemplateOutlet="clearAllFiltersRef" />
  </div>
  <button
    data-test="product-category--filters-trigger-btn"
    #trigger (click)="launch()"
    class="btn filters--trigger"
    [ngClass]="{'filters--trigger__opened': isOpen$ | async}"
    [attr.aria-label]="'productList.filters.show' | cxTranslate"
  >
    @if (isOpen$ | async) {
      {{ 'productList.filters.hide' | cxTranslate }}
    } @else {
      {{ 'productList.filters.show' | cxTranslate }}
    }
    <mat-icon
      class="filters--trigger-icon" svgIcon="arrow-down"
      data-test="product-category--filters-trigger-icon"
    ></mat-icon>
  </button>
</section>
@if (isOpen$| async) {
  <div class="filters--body" @fadeInContentByHeightOpacity data-test="product-category--filters-body">
    <div class="filters--mobile-header" data-test="product-category--filters-mobile-header">
      {{ 'productList.filters.title' | cxTranslate }}
      <ng-container *ngTemplateOutlet="clearAllFiltersRef" />
      <button class="btn btn-icon" (click)="launch()" data-test="product-category--filters-mobile-close-btn">
        <mat-icon svgIcon="close" />
      </button>
    </div>
    <dp-facet-category-list
      data-test="product-category--filters-list-container"
      (exceededFilters)="onExceededFilters($event)" [showAllFilters]="hasShowAllFacets()"
    />
    @if (exceeded()) {
      <div class="filters--show-all-trigger" data-test="product-category--filters-show-all-trigger-btn">
        <button class="btn btn-link" (click)="onToggleVisibleFacets()">
          @if (hasShowAllFacets()) {
            {{ 'productList.filters.hideAll' | cxTranslate }}
          } @else {
            {{ 'productList.filters.showAll' | cxTranslate }} ({{ countOfActiveFacets$ | async }})
          }
        </button>
      </div>
    }
  </div>
}
<ng-template #clearAllFiltersRef>
  @if (countOfActiveFacets$ | async; as count) {
    <a
      data-test="product-category--filters-clear-all-btn"
      class="active-facet filters--active-filters-btn"
      routerLink="./"
      role="button"
    >
      {{ 'productList.filters.clearAllFilters' | cxTranslate }} ({{ count }})
      <mat-icon class="active-facet--icon" svgIcon="close"></mat-icon>
    </a>
  }
</ng-template>
